import React from "react";
import "../styles/Research.css";
import ArchetypePipeline from "../assets/archetype_pipeline.png";
import ArchetypePerformance from "../assets/archetype_performance.png";
import FineFTPipeline from "../assets/fineft_pipeline.png";
import FineFTPerformance from "../assets/fineft_performance.png";
export default function EarnHFT() {
    return (
        <div>
            <div className="aa">
                <div className="topa">
                    <div className="form-floating">
                        <h3 style={{ fontSize: "42px", textAlign: "center", fontWeight: 700 }}>
                            FineFT
                        </h3>
                    </div>

                    <br />
                    <h5 style={{ fontSize: "30px", textAlign: "justify", fontWeight: 300 }}>
                        (1) We use selective update to handle the non-stationary problem in Fintech.
                    </h5>
                    <h5 style={{ fontSize: "30px", textAlign: "justify", fontWeight: 300 }}>
                        (2) We utilize VAEs to detect the capability boundaries of subagent for each market dynamic, and utilize a conservative policy to avoid drawdown when encountering unfamiliar market states.
                    </h5>
                    <br />
                    <img src={FineFTPipeline} alt="FineFT pipeline" className="img-fluid" />
                </div>
            </div>
            <div className='container' style={{marginTop:'70px'}}>

                <h3 className='History'>
                    Results
                </h3>
                <br />
                <h3 style={{ fontSize: "30px", textAlign: "center", fontWeight: 300 }}>
                    FineFT's performance from 2023/06 to 2023/11 on BTCUSDT
                </h3>

                <br />
                <div >
                    <img src={FineFTPerformance} alt="FineFT performance" className="img-fluid" />
                </div>
            </div>


            <div className="aa">
                <div className="topa">
                    <div className="form-floating">
                        <h3 style={{ fontSize: "42px", textAlign: "center", fontWeight: 700 }}>
                            ArchetypeTrader
                        </h3>
                    </div>

                    <br />
                    <h5 style={{ fontSize: "30px", textAlign: "justify", fontWeight: 300 }}>
                        (1) We discover discrete trading archetypes from expert trading trajectories generated by dynamic programming via self-supervised learning.
                    </h5>
                    <h5 style={{ fontSize: "30px", textAlign: "justify", fontWeight: 300 }}>
                        (2) We train an RL agent to select contextually appropriate archetypes and reconstruct action sequences for the upcoming horizons.
                    </h5>
                    <h5 style={{ fontSize: "30px", textAlign: "justify", fontWeight: 300 }}>
                        (3) We train a policy adapter using regret-informed rewards to refine the archetype actions based on market observations and performances.
                    </h5>
                    <br />
                    <img src={ArchetypePipeline} alt="Archetype pipeline" className="img-fluid" />
                </div>
            </div>

            <div className='container' style={{marginTop:'70px'}}>

                <h3 className='History'>
                    Results
                </h3>
                <br />
                <h3 style={{ fontSize: "30px", textAlign: "center", fontWeight: 300 }}>
                    ArchetypeTrader's performance on BTCUSDT and DOTUSDT
                </h3>

                <br />
                <div >
                    <img src={ArchetypePerformance} alt="Archetype performance" className="img-fluid" />
                </div>
            </div>
        </div>

        


    );
}
